function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import videoAnalyzer from './video_analyzer';
import * as style from '../style/video';

/**
 * The Video React component contains a "React Player"
 * (https://www.npmjs.com/package/react-player) to render for various video
 * types, including Youtube, Vimeo, MP4/MOV, Visual Domain. It accepts string of
 * videoUrl as a prop and has an internal video analyzer to see if the video url
 * is valid. If invalid url is given it will not display anything on the page.
 */
import { jsx as ___EmotionJSX } from "@emotion/core";
export default class Video extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "imageElement", undefined);
    this.state = {
      playing: this.props.isPlaying,
      ytThumbnailUrl: undefined,
      ytVideoId: undefined
    };
    this.handlePlayVideo = this.handlePlayVideo.bind(this);
  }
  /* eslint-disable-next-line camelcase */
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isPlaying !== this.props.isPlaying) {
      this.setState({
        playing: nextProps.isPlaying
      });
    }
  }
  componentDidMount() {
    this.chooseYouTubeThumbnail();
  }
  componentDidUpdate() {
    this.chooseYouTubeThumbnail();
  }
  componentWillUnmount() {
    if (this.imageElement) {
      this.imageElement.onload = undefined;
    }
  }
  handlePlayVideo() {
    if (this.state.playing) {
      this.props.onPause();
    } else {
      this.props.onPlay();
    }
    this.setState(state => ({
      playing: !state.playing
    }));
  }
  chooseYouTubeThumbnail() {
    var videoData = videoAnalyzer(this.props.videoUrl);
    if (!videoData || videoData.videoType !== 'youtube' || this.state.ytVideoId === videoData.videoId) {
      return;
    }
    this.setState({
      ytThumbnailUrl: undefined,
      ytVideoId: videoData.videoId
    }, () => {
      var max = "https://img.youtube.com/vi/".concat(videoData.videoId, "/maxresdefault.jpg");
      var hqd = "https://img.youtube.com/vi/".concat(videoData.videoId, "/hqdefault.jpg");
      if (!this.imageElement) {
        this.imageElement = document.createElement('img');
      }
      var setThumb = ytThumbnailUrl => this.setState({
        ytThumbnailUrl
      });
      this.imageElement.onload = () => {
        // maxresdefault image is 1280 px, the 404 image is not
        // if the image we are given is less than 1280 we assume
        // the maxres image doesn't exist, and fall back to hqdefault
        // (which seems to always exist).
        setThumb(this.naturalWidth < 1280 ? hqd : max);
      };
      this.imageElement.src = max;
    });
  }

  /* eslint-disable jsx-a11y/no-static-element-interactions */
  render() {
    var playing = this.state.playing;
    var videoData = videoAnalyzer(this.props.videoUrl);
    var overlayBgStyle = {};
    var playButton = ___EmotionJSX("span", {
      css: style.buttonWrapper
    });
    var displayControl = true;
    var attachPlayEvent = true;
    var canPlayVideoInline = !!videoData;
    var hidePlayButton = canPlayVideoInline && (playing || videoData.videoType === 'vimeo');
    var hideOverlay = playing || videoData && videoData.videoType !== 'youtube';
    if (this.props.fallbackPosterFrameUrl) {
      overlayBgStyle.backgroundImage = "url('".concat(this.props.fallbackPosterFrameUrl, "')");
    }
    if (!canPlayVideoInline) {
      playButton = ___EmotionJSX("a", {
        rel: "noopener noreferrer",
        target: "_blank",
        href: this.props.videoUrl,
        "aria-label": "Play"
      }, ___EmotionJSX("span", {
        css: style.buttonWrapper
      }));
      displayControl = false;
      attachPlayEvent = false;
      overlayBgStyle.backgroundColor = '#A9AFBA';
    } else if (videoData.videoType === 'file') {
      displayControl = false;
    } else if (videoData.videoType === 'youtube') {
      var thumbnail = this.state.ytThumbnailUrl;
      overlayBgStyle.backgroundImage = thumbnail ? "url(".concat(thumbnail, ")") : '';
    }
    return ___EmotionJSX("div", {
      css: style.wrapper,
      className: this.props.className
    }, ___EmotionJSX("div", {
      css: style.playButton(hidePlayButton),
      onClick: attachPlayEvent ? this.handlePlayVideo : null,
      onKeyPress: attachPlayEvent ? this.handlePlayVideo : null
    }, playButton), ___EmotionJSX("div", {
      "data-testid": "video-overlay",
      css: style.overlay(hideOverlay),
      onClick: this.props.onOverlayClick,
      onKeyPress: this.props.onOverlayClick,
      style: overlayBgStyle
    }), ___EmotionJSX("div", {
      css: style.reactPlayerWrapper(this.props.aspectRatio)
    }, canPlayVideoInline && ___EmotionJSX(ReactPlayer, {
      url: this.props.videoUrl,
      width: "100%",
      height: "100%",
      playing: playing,
      controls: displayControl,
      onBufferEnd: () => {
        // workaround for bug in react-player - if user clicks play,
        // then pauses while the vid is buffering, the vid will continue
        // to play once it's buffered.
        if (!playing && videoData.videoType === 'youtube') {
          // We need to force a state transition from playing to not playing
          // for the player to actually stop as the react-player does not
          // have a public `pause()` instance method
          this.setState(() => ({
            playing: true
          }));
          this.setState(() => ({
            playing: false
          }));
        }
      }
    })));
  }
  /* eslint-enable jsx-a11y/no-static-element-interactions */
}
_defineProperty(Video, "canPlay", videoUrl => !!videoAnalyzer(videoUrl));
Video.propTypes = {
  videoUrl: PropTypes.string.isRequired,
  onPlay: PropTypes.func,
  onPause: PropTypes.func,
  onOverlayClick: PropTypes.func,
  isPlaying: PropTypes.bool,
  aspectRatio: PropTypes.oneOf(['sixteen-nine', 'four-three', 'full-height']),
  className: PropTypes.string,
  fallbackPosterFrameUrl: PropTypes.string
};
Video.defaultProps = {
  isPlaying: false,
  onPlay: () => {},
  onPause: () => {},
  onOverlayClick: () => {},
  aspectRatio: undefined,
  className: undefined,
  fallbackPosterFrameUrl: undefined
};